/**
 * --------------------------------
 * FilterBoxDropdown
 * ================================
 *
 *
 */

import React from 'react';
import { Transition } from 'react-transition-group';
import   Card from '../Card/Card';
import   Overlay from '../Overlay/Overlay';
import { Button } from 'semantic-ui-react';

import { FilterDrawer } from './FilterDrawer';
import { ChipDrawer } from './ChipDrawer';

export class FilterBoxDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDrawerVisible: false
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  handleToggleDrawer = () => {
    this.setState({ isDrawerVisible: !this.state.isDrawerVisible });
  };

  handleFilterChange = ({ name, title, value, selected }) => {
    const selectedOptions = this.props.selected;
    // spread the values into a new immutable array, unless its null, then use an empty arr
    const selectedObj = selectedOptions.find((opt) => opt.name === name);
    let selectedValues =
      selectedObj && selectedObj.values ? [...(selectedObj.values || [])] : [];

    if (selected) {
      // The options was selected, to add it to the selected options, and return the new set
      selectedValues.push(value);
    } else {
      // The options was deselected, so remove it from the selected options, and return the new set
      selectedValues = selectedValues.filter((val) => val !== value);
    }
    this.props.onChange([
      ...selectedOptions.filter((s) => s.name !== name),
      { ...selectedObj, values: selectedValues }
    ]);
  };

  handleDeselectChip = ({ name }) => {
    const { selected } = this.props;
    const selectedObj = selected.find((opt) => opt.name === name);
    this.props.onChange([
      ...selected.filter((s) => s.name !== name),
      { ...selectedObj, values: [] }
    ]);
  };

  render() {
    const { options, selected } = this.props;
    const { isDrawerVisible } = this.state;

    const defaultStyle = {
      transition: 'all 300ms cubic-bezier(0.08, 0.68, 0.46, 1.06)',
      maxHeight: 0,
      visibility: 'hidden'
    };
    const transitionStyles = {
      entering: {
        maxHeight: '374px',
        visibility: 'visible',
        boxShadow:
          '0 4px 8px 0 rgba(55,93,112,0.1) inset, 0 10px 15px 0 rgba(55,93,112,0.22)'
      },
      entered: {
        maxHeight: '374px',
        visibility: 'visible',
        boxShadow:
          '0 4px 8px 0 rgba(55,93,112,0.1) inset, 0 10px 15px 0 rgba(55,93,112,0.22)'
      }
    };

    return (
      <div className="FilterBoxDropdown">
        <Card bodyStyle={{ justifyContent: 'unset' }}>
          <Button onClick={this.handleToggleDrawer} className="drawerToggle">
            <i
              className={
                this.state.isDrawerVisible
                  ? 'angle up icon'
                  : 'icon icon-filter'
              }
            />
            Filter
          </Button>

          <ChipDrawer
            selected={selected}
            handleDeselectChip={this.handleDeselectChip}
          />
        </Card>
        <Overlay
          onClick={this.handleToggleDrawer}
          zIndex={'99'}
          isVisible={isDrawerVisible}
        />
        <Transition in={isDrawerVisible} timeout={500}>
          {(state) => (
            <FilterDrawer
              style={{ ...defaultStyle, ...transitionStyles[state] }}
              options={options}
              selected={selected}
              onClose={this.handleToggleDrawer}
              onChange={this.handleFilterChange}
              onClear={this.handleClearFilters}
            />
          )}
        </Transition>
      </div>
    );
  }
}

export default FilterBoxDropdown;
